interface RateLimitState {
  count: number;
  lastRequest: number;
  resetTime: number;
}

const RATE_LIMIT = {
  WINDOW_MS: 15 * 60 * 1000, // 15 minutes
  MAX_REQUESTS: 100,
};

const rateLimitMap = new Map<string, RateLimitState>();

export const checkRateLimit = (ip: string): { allowed: boolean; retryAfter?: number } => {
  const now = Date.now();
  const rateLimit = rateLimitMap.get(ip) || {
    count: 0,
    lastRequest: now,
    resetTime: now + RATE_LIMIT.WINDOW_MS,
  };

  // Reset counter if window has passed
  if (now > rateLimit.resetTime) {
    rateLimit.count = 0;
    rateLimit.resetTime = now + RATE_LIMIT.WINDOW_MS;
  }

  // Check if rate limit exceeded
  if (rateLimit.count >= RATE_LIMIT.MAX_REQUESTS) {
    return {
      allowed: false,
      retryAfter: Math.ceil((rateLimit.resetTime - now) / 1000),
    };
  }

  // Update rate limit
  rateLimit.count++;
  rateLimit.lastRequest = now;
  rateLimitMap.set(ip, rateLimit);

  return { allowed: true };
};

// Clean up old entries periodically
setInterval(() => {
  const now = Date.now();
  for (const [ip, data] of rateLimitMap.entries()) {
    if (now - data.lastRequest > RATE_LIMIT.WINDOW_MS * 2) {
      rateLimitMap.delete(ip);
    }
  }
}, RATE_LIMIT.WINDOW_MS);
